export default "__VITE_ASSET__CiGWrxHW__"